import { useCallback, useMemo } from 'react';
import { applyExcelFormats } from '../../../../utils/excel';
import { CONSUMER_ANALYTICS_COLUMNS } from '../../../../constants/reports';
import { exportReportFile, processReport } from '../../../../utils/reports';
import ReportActionRow from '../ReportActionRow';
import ReportList from '../ReportList';

function ReportConsumerAnalytics({
  reportTitle,
  reportDetails,
  reportId,
  reportFileName,
  reportType,
  setSpinner,
  report,
}) {
  const { processedReport } = useMemo(
    () => processReport(reportType, report),
    [reportType, report],
  );

  const formattedReport = useMemo(() => {
    if (processedReport.length > 0) {
      return processedReport.map(r =>
        Object.entries(r).reduce(
          (acc, [key, value]) => ({
            ...acc,
            [key]:
              value !== null
                ? applyExcelFormats(value, CONSUMER_ANALYTICS_COLUMNS[key]?.style?.numFmt)
                : null,
          }),
          {},
        ),
      );
    }

    return [];
  }, [processedReport]);

  const formatCellConditionally = useCallback(({ reportItem, tableColumnKey }) => {
    if (tableColumnKey === 'offer' && !String(reportItem[tableColumnKey]).startsWith('$')) {
      return ' justify-content-start text-start';
    }

    return '';
  }, []);

  return (
    <>
      <ReportActionRow
        reportTitle={reportTitle}
        reportDetails={reportDetails}
        reportId={reportId}
        setSpinner={setSpinner}
        exportFile={() => exportReportFile({ reportType, reportFileName, report })}
      />
      <ReportList
        report={formattedReport}
        tableColumns={CONSUMER_ANALYTICS_COLUMNS}
        rowKey="id"
        formatCellConditionally={formatCellConditionally}
      />
    </>
  );
}

export default ReportConsumerAnalytics;
